import { Button } from '@mantine/core';
import { Select, variants, Modal } from '@uag/react-core';
import { AddressModelCountryConfiguration } from '@uag/welcome-shared/src/api/models';
import { useGetBranchesByCountryCode } from '@uag/welcome-shared/src/api/queries/branches/branches';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { create, InstanceProps } from 'react-modal-promise';

type ForwardResult = { identifier: string; name: string };

type RemarkModalProps = {
    countryConfiguration: AddressModelCountryConfiguration;
} & InstanceProps<ForwardResult>;

const ForwardRequestModal = ({ countryConfiguration, isOpen, onResolve, onReject }: RemarkModalProps) => {
    const { t } = useTranslation();
    const [selectedBranchId, setSelectedBranchId] = useState<string | null>(null);

    const submit = () => {
        if (selectedBranchId) {
            const selectedBranch = branches?.data?.find((branche) => branche.id === selectedBranchId);
            if (selectedBranch?.identifier) {
                onResolve({ identifier: selectedBranch.identifier, name: selectedBranch.name });
            }
        }
    };
    const reject = () => onReject();

    const countryCode = countryConfiguration?.countryCode;
    const { data: branches } = useGetBranchesByCountryCode(countryCode ?? '');
    const branchOptions = branches?.data?.map((branche) => ({
        value: branche.id,
        label: `${branche.identifier} - ${branche.name}`,
    }));
    return (
        <Modal opened={isOpen} size="lg" title={t('forwardRequestTitle')} onAbort={reject} onClose={reject}>
            <div className="gap-base flex flex-col">
                <div className="text-text-ultra-light text-base">{t('forwardRequestMessage')}</div>
                <Select
                    data={branchOptions}
                    placeholder={t('selectTeam')}
                    value={selectedBranchId}
                    onChange={setSelectedBranchId}
                />
            </div>
            <Modal.Footer>
                <Button className="modal-action" variant={variants.button.secondary} onClick={reject}>
                    {t('cancel')}
                </Button>
                <Button className="modal-action" onClick={submit}>
                    {t('forward')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export const openForwardRequestModal = create(ForwardRequestModal);
